/**
 * Thin wrapper over src/client/cores/systems.js.
 *
 * Re-exports the `SYSTEMS` map and exposes a library-friendly view over it:
 * `LIBRARY_SYSTEMS` is an ordered array of { id, name, maxPlayers } used by
 * the system filter chips and the sidebar.
 *
 * Importing from the main app path is deliberate — this module is pure
 * static data, safe to share. esbuild will inline it into our bundle; the
 * main app gets its own copy (total cost: a few KB). Cheaper than
 * maintaining a parallel list that can drift.
 */

import { SYSTEMS, detectSystem } from '../../../../src/client/cores/systems.js';
import { systemName as sharedSystemName } from '../../../../src/shared/system-label.js';

export { SYSTEMS, detectSystem };

// Canonical display order — release date, matching the main app's system
// selector. `gbc` is intentionally absent (aliases to GB core).
const DISPLAY_ORDER = ['atari2600', 'c64', 'nes', 'genesis', 'gb', 'snes', 'gba', 'n64'];

export const LIBRARY_SYSTEMS = DISPLAY_ORDER
  .filter(id => SYSTEMS[id])
  .map(id => ({
    id,
    name: SYSTEMS[id].name,
    maxPlayers: SYSTEMS[id].maxPlayers || 1,
    extensions: SYSTEMS[id].extensions,
  }));

export function systemName(id) {
  if (!id) return '';
  if (id === 'all') return 'All systems';
  return sharedSystemName(id);
}

export function enabledLibrarySystems(features) {
  if (!features || !Object.keys(features).length) return LIBRARY_SYSTEMS;
  return LIBRARY_SYSTEMS.filter(s => features[`system:${s.id}`] !== false);
}
